The values to replace on a posted position profile.
